import { all, takeLatest } from 'redux-saga/effects';

import { DadosClienteTypes } from '../ducks/dados-cliente';
import { CombosTypes } from '../ducks/combos';
import { ListaBensTypes } from '../ducks/lista-bens';
import { DadosComplementaresTypes } from './../ducks/dados-complementares';

import { buscaAgencia } from './dados-cliente';
import { calcularCotacao, salvarCotacao } from './combos';
import { sendLista, getMinMaxVigencia } from './lista-bens';
import { sendDadosComplementares } from './dados-complementares';
import { HistoricoAcessoTypes } from '../ducks/historico-acesso';
import { buscarHistoricoAcesso } from './historico-acesso';

//Como se fosse o combine reducers do SAGA
// o * significa uma função generator do JS, parecido com async/await
// o takeLatest pega sempre a última requisição feita pelo cliente.
export function* buscaAgenciaSaga() {
    yield takeLatest(DadosClienteTypes.OBTER_AGENCIA_REQUEST, buscaAgencia);
}
export function* calcularCotacaoSaga() {
    yield takeLatest(CombosTypes.CALCULAR_COTACAO, calcularCotacao);
}
export function* salvarCotacaoSaga() {
    yield takeLatest(CombosTypes.SALVAR_COTACAO, salvarCotacao);
}
export function* sendListaSaga() {
    yield takeLatest(ListaBensTypes.SEND_LISTA_BENS, sendLista);
}

export function* getMinMaxVigenciaSaga() {
    yield takeLatest(ListaBensTypes.MINIMO_MAXIMO_VIGENCIA, getMinMaxVigencia);
}

export function* sendDadosComplementaresSaga() {
    yield takeLatest(DadosComplementaresTypes.SEND_DADOS_COMPLEMENTARES, sendDadosComplementares);
}

export function* buscarHistoricoAcessoSaga() {
    yield takeLatest(HistoricoAcessoTypes.SET_HISTORICO_ACESSO, buscarHistoricoAcesso);
}

export default function* rootSaga() {
    yield all([
        buscaAgenciaSaga(),
        calcularCotacaoSaga(),
        salvarCotacaoSaga(),
        sendListaSaga(),
        getMinMaxVigenciaSaga(),
        sendDadosComplementaresSaga(),
        buscarHistoricoAcessoSaga()
    ]);
}
